<template>
  <b-card no-body>
    <b-card-header>
      <div class="d-flex align-items-center card-title-responsive-40">
        <feather-icon
          size="24"
          class="mr-1 d-none d-sm-block"
          icon="MailIcon"
        />
        <b-card-title class="ml-25">
          {{ $t('navigation.list-contributors') }}
        </b-card-title>
      </div>
      <b-button-group class="ml-1">
        <b-button
          v-if="isUserAllowWrite && !cpid"
          class="btn-icon"
          variant="outline-primary"
          :to="{ name: 'view-contributors', params: { id: 0 } }"
        >
          <feather-icon
            class="text-nowrap d-block d-sm-none"
            icon="FileIcon"
          />
          <span class="text-nowrap d-none d-sm-block">{{ $t('contributors.add-new') }}</span>
        </b-button>
        <b-button
          class="btn-icon"
          variant="outline-primary"
          @click="expoort()"
        >
          <feather-icon
            class="text-nowrap d-block d-sm-none"
            icon="ExternalLinkIcon"
          />
          <span class="text-nowrap d-none d-sm-block">{{ $t('common.export') }}</span>
        </b-button>
        <b-button
          v-if="!cpid"
          id="btn-clean"
          variant="outline-primary"
          class="btn-icon"
          @click="clearFilters()"
        >
          <feather-icon icon="Trash2Icon" />
          <b-tooltip
            triggers="hover"
            target="btn-clean"
            :title=" $t('common.clean-filter')"
            :delay="{ show: 100, hide: 50 }"
          />
        </b-button>
        <b-button
          id="btn-refresh"
          variant="outline-primary"
          class="btn-icon"
          @click="refresh()"
        >
          <feather-icon icon="RefreshCcwIcon" />
          <b-tooltip
            triggers="hover"
            target="btn-refresh"
            :title=" $t('common.refresh')"
            :delay="{ show: 100, hide: 50 }"
          />
        </b-button>
      </b-button-group>
    </b-card-header>

    <b-card-body>
      <contributors-list-table
        ref="contributorsListTable"
        :cpid="cpid"
        :is-linked="isLinked"
        :linked-area="linkedArea"
      />
    </b-card-body>
  </b-card>
</template>

<script>
/* eslint-disable vue/require-prop-types */
import {
  BCard, BCardBody, BCardHeader, BButton, BCardTitle, BButtonGroup, BTooltip,
} from 'bootstrap-vue'
import authService from '@/vue.auth.service'
import ContributorsListTable from '@/views/contributors/ContributorsListTable.vue'

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BButton,
    BCardTitle,
    BButtonGroup,
    BTooltip,
    ContributorsListTable,
  },
  props: {
    cpid: {
      required: false,
      default: null,
    },
    isLinked: {
      required: false,
      default: null,
    },
    linkedArea: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isUserAllowWrite: authService.isUserInRole('write'),
    }
  },
  methods: {
    expoort() {
      this.$refs.contributorsListTable.expoort()
    },
    refresh() {
      this.$refs.contributorsListTable.refresh()
    },
    clearFilters() {
      this.$refs.contributorsListTable.clearFilters()
    },
  },
}
</script>
